import { BFormRadio } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormRadio when migrating. */
export const EgBFormRadio = createEgBootstrapProxy("EgBFormRadio", BFormRadio);
